import { render, staticRenderFns } from "./StorePurchase.vue?vue&type=template&id=b5f314aa&scoped=true"
import script from "./StorePurchase.vue?vue&type=script&lang=js"
export * from "./StorePurchase.vue?vue&type=script&lang=js"
import style0 from "./StorePurchase.vue?vue&type=style&index=0&id=b5f314aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f314aa",
  null
  
)

export default component.exports